import React from 'react';

import { SearchInput2 } from '@gogame/components';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import { SET_DIMENSION_SEARCH_QUERY } from 'scenes/Trackers/Tracker/reducers';

export const DimensionSearch = ({ disabled }) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const handleEnter = async (_e, value) => {
    dispatch({
      type: SET_DIMENSION_SEARCH_QUERY,
      payload: value,
    });
  };
  return (
    <SearchInput2
      placeholder={'Search in dimension'}
      onEnter={handleEnter}
      value={screenState.dimensionSearchQuery}
      disabled={disabled}
      debounceTimeout={0}
    />
  );
};
